import { EInvoicingGetStarted } from '../EInvoicingGetStarted'
import { EInvoicingGenericStep } from '../EInvoicingStep/elements/EInvoicingGenericStep'
import { EInvoicingStepContainer } from '../EInvoicingStep/elements/EInvoicingStepContainer'

export const EInvoicingEmptyStateStep = () => {
  return (
    <EInvoicingStepContainer>
      <EInvoicingGenericStep fullwidth={true}>
        <EInvoicingGetStarted proceedToNextStep={true} />
      </EInvoicingGenericStep>
    </EInvoicingStepContainer>
  )
}
